
/**
 * Deserializes a base64 string containing a json value.
 * @param value
 * @constructor
 */
export function Base64ToObject<TData>(value: string): TData {
  const decodedValue = atob(value);

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return JSON.parse(decodedValue) as TData;
}

/**
 * Serializes an object into a json string, then encodes that string to base 64.
 * @param {any} value
 * @constructor
 */
export function ObjectToBase64<TValue = unknown>(value: TValue) {
  const stringified = JSON.stringify(value);

  return btoa(stringified);
}
